import { render, staticRenderFns } from "./fa_conversation_viewer.vue?vue&type=template&id=236e00ca&scoped=true&"
import script from "./fa_conversation_viewer.vue?vue&type=script&lang=js&"
export * from "./fa_conversation_viewer.vue?vue&type=script&lang=js&"
import style0 from "./fa_conversation_viewer.vue?vue&type=style&index=0&id=236e00ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e00ca",
  null
  
)

export default component.exports